import React from 'react';
import Layout from '../../components/Layout';
import Register from './Register';
import messages from '../../locale/jsonMessages';

export default async function action({ store, query, intl }) {

  const title = intl?.formatMessage(messages.registerUser);

  // From Redux Store
  let isAuthenticated = store.getState().runtime.isAuthenticated;
  let refer = query.refer;

  if (isAuthenticated) {
    return { redirect: '/' };
  }

  return {
    title,
    component: <Layout><Register title={title} refer={refer} /></Layout>,
  };
};
